import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ContentPrivacyAndTerms } from "../../content.types";
import { requestGetPrivacyAndTerms } from "./requestGetPrivacyAndTerms.request";

const useGetPrivacyAndTerms = (
  options?: QueryOptions<ContentPrivacyAndTerms, ApiServiceError<ApiError>>
) => {
  const { data: privacyAndTerms, ...rest } = useQuery({
    queryKey: ["content-privacy-admin"],
    queryFn: async () => await requestGetPrivacyAndTerms(),
    onError: toastServerError,
    ...options
  });

  return { privacyAndTerms, ...rest };
};

export default useGetPrivacyAndTerms;
